import type { RightResult, RouterOutputs } from '../types/TRPC';

export type KybStatusData = RightResult<RouterOutputs['getKybStatus']>;

export const VERIFICATION_DEADLINE = 'Required now';

export interface VerificationFlags {
  hasApplicant: boolean;
  isNotStarted: boolean;
  isInProgress: boolean;
  isUnderReview: boolean;
  isApproved: boolean;
  isRejected: boolean;
  needsAdditionalInfo: boolean;
  canResume: boolean;
}

export const getVerificationFlags = (
  status?: KybStatusData | null,
): VerificationFlags => {
  const currentStatus = status?.status;
  const hasApplicant = Boolean(status?.sumsubApplicantId);
  const isNotStarted = currentStatus === 'NotStarted';
  const isInProgress = currentStatus === 'InProgress';
  const isUnderReview = currentStatus === 'UnderReview';
  const isApproved = currentStatus === 'Approved';
  const isRejected = currentStatus === 'Rejected';
  const needsAdditionalInfo = currentStatus === 'RequiresAdditionalInfo';

  const canResume =
    isInProgress || needsAdditionalInfo || (isNotStarted && hasApplicant);

  return {
    hasApplicant,
    isNotStarted,
    isInProgress,
    isUnderReview,
    isApproved,
    isRejected,
    needsAdditionalInfo,
    canResume,
  };
};
